import { motion } from "framer-motion";
import { textContainer, textVariant2 } from "./motion";
import "./CustomText.css";

export const TypingText = ({ title, textStyles }) => (
  <motion.p
    variants={textContainer}
    className={`typetext text-secondary-white ${textStyles}`}
  >
    {Array.from(title).map((letter, index) => (
      <motion.span variants={textVariant2} key={index}>
        {letter === " " ? "\u00A0" : letter}
      </motion.span>
    ))}
  </motion.p>
);
